
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-chatbot-templates",
      function () {
        return require("private-next-pages/whatsapp-chatbot-templates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-chatbot-templates"])
      });
    }
  